interface PdfSaveButtonProps {
  dirty?: boolean;
  busy?: boolean;
  /** Dark app bar (phone) vs light toolbar (desktop). */
  tone?: 'light' | 'dark';
  onSave: () => void;
}

function SaveIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden>
      <path
        fill="currentColor"
        d="M5 3h11.2L21 7.8V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm1 2v6h10V5H6Zm0 14h12v-6H6v6Zm2-4h3v3H8v-3Zm1-11h6v4H9V5Z"
      />
    </svg>
  );
}

/** Floppy-style save icon with unsaved indicator. */
export default function PdfSaveButton({
  dirty,
  busy,
  tone = 'light',
  onSave,
}: PdfSaveButtonProps) {
  return (
    <button
      type="button"
      className={`pdfe-save-btn${tone === 'dark' ? ' is-dark' : ''}${
        dirty ? ' is-dirty' : ''
      }`}
      disabled={busy}
      title={dirty ? 'Save (Ctrl+S)' : 'Saved'}
      aria-label={dirty ? 'Save PDF' : 'PDF saved'}
      onClick={onSave}
    >
      <SaveIcon />
      {dirty && !busy ? <span className="pdfe-save-dot" aria-hidden /> : null}
    </button>
  );
}
